import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { listRemarksTemplates, createRemarksTemplate, updateRemarksTemplate, deleteRemarksTemplate } from "../../api/examRemarksApi";
import "../Users/UsersPage.css";

const emptyForm = { remarksTitle: "", remarks: "" };

/**
 * Direct port of digicampusbd's remark-template CRUD (`ExamRemarksController`'s
 * `/remarks/template/*`, was `exam-remarks-template`) — a reusable remark
 * preset (short title + full remark text) applied to many students' exam
 * results at once via `exam-remarks-give`.
 */
export default function ExamRemarksTemplatePage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);

  const load = () => {
    setLoading(true);
    listRemarksTemplates()
      .then(setTemplates)
      .catch(() => setError("Failed to load remarks templates."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      if (editingId) {
        await updateRemarksTemplate(editingId, form);
        setSuccess("Remarks template updated.");
      } else {
        await createRemarksTemplate(form);
        setSuccess("Remarks template created.");
      }
      setForm(emptyForm);
      setEditingId(null);
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save.");
    }
  };

  const handleEdit = (row) => {
    setEditingId(row.id);
    setForm({ remarksTitle: row.remarksTitle, remarks: row.remarks });
  };

  const handleDelete = async (row) => {
    if (!window.confirm(`Delete remarks template "${row.remarksTitle}"?`)) return;
    setError("");
    try {
      await deleteRemarksTemplate(row.id);
      setSuccess("Deleted.");
      setTemplates((prev) => prev.filter((t) => t.id !== row.id));
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete.");
    }
  };

  const columns = [
    { key: "remarksTitle", label: "Title" },
    { key: "remarks", label: "Remarks" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Result Remarks Setup</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <form onSubmit={handleSubmit} className="user-form" style={{ marginTop: 16, marginBottom: 24 }}>
        <label>Title *</label>
        <input value={form.remarksTitle} onChange={(e) => setForm({ ...form, remarksTitle: e.target.value })} required placeholder="e.g. Excellent" />
        <label>Remarks *</label>
        <textarea value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} required placeholder="Full remark text" />
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            {editingId ? "Update" : "+ Add"} Remarks Template
          </button>
          {editingId && (
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                setEditingId(null);
                setForm(emptyForm);
              }}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={templates}
          actions={(row) => (
            <>
              <button type="button" className="btn-link" onClick={() => handleEdit(row)}>
                Edit
              </button>{" "}
              <button type="button" className="btn-link danger" onClick={() => handleDelete(row)}>
                Delete
              </button>
            </>
          )}
        />
      )}
    </MainLayout>
  );
}
